import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { BudgetForecastEntry } from 'lumen/models';

interface SettingsBudgetForecastTablesCellsTdEntryTitleSignature {
  Args: {
    cellData: BudgetForecastEntry;
  };
}

const SettingsBudgetForecastTablesCellsTdEntryTitle = <template>
  <div class="flex items-center gap-100" data-test-td="entry-title">
    {{#if @cellData.isLocked}}
      <PrismIcon @name="lock" @size="small" data-test-icon="lock" />
    {{/if}}

    {{@cellData.titleWithDefault}}

    {{#if @cellData.isMain}}
      <PrismBadge @badgeType="info" @label={{t "budget_forecast.main"}} />
    {{/if}}
  </div>
</template> satisfies TOC<SettingsBudgetForecastTablesCellsTdEntryTitleSignature>;

export default SettingsBudgetForecastTablesCellsTdEntryTitle;
